<p-sidebar
  [(visible)]="visible"
  (visibleChange)="onVisibleChange($event)"
  position="right"
  [style]="{ width: '720px' }"
  [modal]="false"
  [showCloseIcon]="true"
  [blockScroll]="false"
  [closeOnEscape]="true"
  [appendTo]="'body'"
>
  <ng-template pTemplate="header">
    <afoone-wxrl-form-header
      [title]="drawerTitle"
      [activeTab]="'Disparadores'"
    >
    </afoone-wxrl-form-header>
  </ng-template>

  <div class="drawer-content" [formGroup]="triggerForm">
    <!-- Campo oculto: PosR de BD en edición; no editar (#559). En alta el servidor asigna el siguiente. -->
    <input type="hidden" formControlName="posR" />

    <!-- Estado -->
    <div class="field">
      <label for="ruleState">{{ 'WXRL.SCHEMA.STATE' | translate }} *</label>
      <p-dropdown
        id="ruleState"
        formControlName="ruleState"
        [options]="triggerStates"
        optionLabel="label"
        optionValue="value"
        placeholder="{{ 'WXRL.SCHEMA.SELECT_STATE' | translate }}"
        [showClear]="true"
        [virtualScroll]="true"
        [virtualScrollItemSize]="38"
        styleClass="w-full"
      ></p-dropdown>
      <small
        class="p-error"
        *ngIf="
          triggerForm.get('ruleState')?.invalid &&
          triggerForm.get('ruleState')?.touched
        "
      >
        {{ 'WXRL.SCHEMA.STATE_REQUIRED' | translate }}
      </small>
    </div>

    <!-- Tipo de Disparador -->
    <div class="field">
      <label for="subjectType">{{ 'WXRL.SCHEMA.TRIGGER_TYPE' | translate }} *</label>
      <p-dropdown
        id="subjectType"
        formControlName="subjectType"
        [options]="triggerTypes"
        optionLabel="label"
        optionValue="value"
        placeholder="{{ 'WXRL.SCHEMA.SELECT_TRIGGER_TYPE' | translate }}"
        [showClear]="true"
        styleClass="w-full"
      ></p-dropdown>
      <small
        class="p-error"
        *ngIf="
          triggerForm.get('subjectType')?.invalid &&
          triggerForm.get('subjectType')?.touched
        "
      >
        {{ 'WXRL.SCHEMA.TRIGGER_TYPE_REQUIRED' | translate }}
      </small>
    </div>

    <!-- Campo Texto (solo RXTX) -->
    <div class="field" *ngIf="showTextField">
      <label for="textNr">{{ 'WXRL.SCHEMA.TEXT' | translate }} *</label>
      <p-dropdown
        id="textNr"
        formControlName="textNr"
        [options]="textResults"
        optionLabel="label"
        optionValue="value"
        placeholder="{{ 'WXRL.SCHEMA.SELECT_TEXT' | translate }}"
        [filter]="true"
        [showClear]="true"
        [virtualScroll]="true"
        [virtualScrollItemSize]="38"
        styleClass="w-full"
      ></p-dropdown>
      <small
        class="p-error"
        *ngIf="
          triggerForm.get('textNr')?.invalid &&
          triggerForm.get('textNr')?.touched
        "
      >
        {{ 'WXRL.SCHEMA.TEXT_REQUIRED' | translate }}
      </small>
    </div>

    <!-- Tipo de Alarma (solo RXAL) -->
    <div class="field" *ngIf="showAlarmFields">
      <label for="alarmStatus">{{ 'WXRL.SCHEMA.ALARM_TYPE' | translate }} *</label>
      <p-dropdown
        id="alarmStatus"
        formControlName="alarmStatus"
        [options]="alarmTypes"
        optionLabel="label"
        optionValue="value"
        placeholder="{{ 'WXRL.SCHEMA.SELECT_ALARM_TYPE' | translate }}"
        [filter]="true"
        [showClear]="true"
        [virtualScroll]="true"
        [virtualScrollItemSize]="38"
        styleClass="w-full"
      ></p-dropdown>
      <small
        class="p-error"
        *ngIf="
          triggerForm.get('alarmStatus')?.invalid &&
          triggerForm.get('alarmStatus')?.touched
        "
      >
        {{ 'WXRL.SCHEMA.ALARM_TYPE_REQUIRED' | translate }}
      </small>
    </div>

    <!-- Prueba (siempre visible) -->
    <div class="field">
      <label for="methNrFilter">{{ 'WXRL.SCHEMA.TEST' | translate }}<span *ngIf="triggerForm.get('subjectType')?.value === 'RXPR' || triggerForm.get('subjectType')?.value === 'Prueba'"> *</span></label>
      <p-dropdown
        id="methNrFilter"
        formControlName="methNrFilter"
        [options]="triggerTests"
        optionLabel="label"
        optionValue="value"
        placeholder="{{ 'WXRL.SCHEMA.SELECT_TEST' | translate }}"
        [filter]="true"
        [showClear]="true"
        [virtualScroll]="true"
        [virtualScrollItemSize]="38"
        styleClass="w-full"
      ></p-dropdown>
      <small
        class="p-error"
        *ngIf="
          (triggerForm.get('subjectType')?.value === 'RXPR' || triggerForm.get('subjectType')?.value === 'Prueba') &&
          triggerForm.get('methNrFilter')?.invalid &&
          triggerForm.get('methNrFilter')?.touched
        "
      >
        {{ 'WXRL.SCHEMA.TEST_REQUIRED' | translate }}
      </small>
    </div>

    <!-- Evento Disparador -->
    <div class="field">
      <label for="triggEvent">{{ 'WXRL.SCHEMA.TRIGGER_EVENT' | translate }} *</label>
      <p-dropdown
        id="triggEvent"
        formControlName="triggEvent"
        [options]="triggerEvents"
        optionLabel="label"
        optionValue="value"
        placeholder="{{ 'WXRL.SCHEMA.SELECT_TRIGGER_EVENT' | translate }}"
        [showClear]="true"
        [virtualScroll]="true"
        [virtualScrollItemSize]="38"
        styleClass="w-full"
      ></p-dropdown>
      <small
        class="p-error"
        *ngIf="
          triggerForm.get('triggEvent')?.invalid &&
          triggerForm.get('triggEvent')?.touched
        "
      >
        {{ 'WXRL.SCHEMA.TRIGGER_EVENT_REQUIRED' | translate }}
      </small>
    </div>

    <!-- Acción (solo RXAL) -->
    <div class="field" *ngIf="showAlarmFields">
      <label for="alarmFilter">{{ 'WXRL.SCHEMA.ACTION' | translate }} *</label>
      <p-dropdown
        id="alarmFilter"
        formControlName="alarmFilter"
        [options]="alarmActions"
        optionLabel="label"
        optionValue="value"
        placeholder="{{ 'WXRL.SCHEMA.SELECT_ACTION' | translate }}"
        [virtualScroll]="true"
        [virtualScrollItemSize]="38"
        styleClass="w-full"
      ></p-dropdown>
      <small
        class="p-error"
        *ngIf="
          triggerForm.get('alarmFilter')?.invalid &&
          triggerForm.get('alarmFilter')?.touched
        "
      >
        {{ 'WXRL.SCHEMA.ACTION_REQUIRED' | translate }}
      </small>
    </div>

    <!-- Filtro Petición -->
    <div class="field">
      <label for="auftrNrTest">{{ 'WXRL.SCHEMA.REQUEST_FILTER' | translate }}</label>
      <input
        id="auftrNrTest"
        type="text"
        pInputText
        formControlName="auftrNrTest"
        class="w-full"
        maxlength="14"
      />
    </div>

    <!-- Depurar -->
    <div class="field">
      <label for="debug">{{ 'WXRL.SCHEMA.DEBUG' | translate }} *</label>
      <p-dropdown
        id="debug"
        formControlName="debug"
        [options]="debugOptions"
        optionLabel="label"
        optionValue="value"
        styleClass="w-full"
      ></p-dropdown>
      <small
        class="p-error"
        *ngIf="
          triggerForm.get('debug')?.invalid &&
          triggerForm.get('debug')?.touched
        "
      >
        {{ 'WXRL.SCHEMA.DEBUG_REQUIRED' | translate }}
      </small>
    </div>

    <div class="field" *ngIf="showIsolationField">
      <label for="isolation">{{ 'WXRL.SCHEMA.ISOLATION' | translate }}</label>
      <p-dropdown
        id="isolation"
        formControlName="isolation"
        [options]="isolationOptions"
        optionLabel="label"
        optionValue="value"
        placeholder="{{ 'WXRL.SCHEMA.SELECT_ISOLATION' | translate }}"
        [virtualScroll]="true"
        [virtualScrollItemSize]="38"
        styleClass="w-full"
      ></p-dropdown>
    </div>

    <!-- Comentario -->
    <div class="field">
      <label for="kommentar">{{ 'WXRL.SCHEMA.COMMENT' | translate }}</label>
      <textarea
        id="kommentar"
        pInputTextarea
        formControlName="kommentar"
        rows="3"
        class="w-full"
        [maxlength]="255"
      ></textarea>
      <small class="p-text-secondary">
        {{ triggerForm.get('kommentar')?.value?.length || 0 }} / 255
      </small>
      <small
        class="p-error"
        *ngIf="
          triggerForm.get('kommentar')?.hasError('maxlength') &&
          triggerForm.get('kommentar')?.touched
        "
      >
        {{ 'WXRL.SCHEMA.COMMENT_MAXLENGTH_ERROR' | translate }}
      </small>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="drawer-footer">
      <p-button
        [label]="'WXRL.SCHEMA.CANCEL' | translate"
        icon="pi pi-times"
        (click)="onCancel()"
        severity="secondary"
        [text]="true"
      ></p-button>
      <p-button
        [label]="isEditMode ? ('WXRL.SCHEMA.UPDATE' | translate) : ('WXRL.SCHEMA.SAVE' | translate)"
        icon="pi pi-check"
        (click)="onSave()"
        [disabled]="triggerForm.invalid"
      ></p-button>
    </div>
  </ng-template>
</p-sidebar>
